"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _basicEmptyCheck = _interopRequireDefault(require("./basicEmptyCheck"));

var _isEmpty = _interopRequireDefault(require("./isEmpty"));

function checkRequired(value, trim, emptyAllowed) {
  // String trim
  if (trim && typeof value === 'string') {
    value = value.replace(/(^\s*)|(\s*$)/g, '');
  }

  if (emptyAllowed) {
    return !(0, _basicEmptyCheck["default"])(value);
  } // Array


  if (Array.isArray(value)) {
    return !!value.length;
  }

  return !(0, _isEmpty["default"])(value);
}

var _default = checkRequired;
exports["default"] = _default;